export enum FormVariant {
  Creation = 'creation',
  Modification = 'modification',
}
